import {TVehicleConfiguration} from "../components/settings/VehicleConfiguration/VehicleConfiguration";

export const getVehicleDwellTime = (
  vehicleDescription: string | null | undefined,
  vehicleConfigurationPref: TVehicleConfiguration[] | null | undefined
): number | undefined => {
  if (!vehicleConfigurationPref || vehicleConfigurationPref.length === 0 || !vehicleDescription) {
    return undefined;
  }
  const lowerCaseVehicleDescription = vehicleDescription.toLowerCase();
  for (const configuration of vehicleConfigurationPref) {
    const lowerCaseValues: string[] = configuration.value.map((v) => v.toLowerCase());
    if (lowerCaseValues.includes(lowerCaseVehicleDescription)) {
      return configuration.dwellTime;
    }
  }
  return undefined;
};
